export const DCSEventTypes = [
	{
		label: "Full Year",
		value: "full_year",
	},
	{
		label: "Partial(Change of Company)",
		value: "partial_change_of_company",
	},
	{ label: "Partial(Change of Flag)", value: "partial_change_of_flag" },
	{
		label: "Partial(Change of Company and Flag)",
		value: "partial_change_of_flag_and_company_name",
	},
];

export const EUMRVEventTypes = [
	{
		label: "Full Year",
		value: "full_year",
	},
	{
		label: "Partial(Change of Company)",
		value: "partial_change_of_company",
	},
];

export const UKMRVEventTypes = [
	{
		label: "Full Year",
		value: "full_year",
	},
	{
		label: "Partial(From 1-Jan-2026 to 02-Apr-2026)",
		value: "partial_from_1_jan_2026_to_2_apr_2026",
	}
];

export const FEUMRVEventTypes = [
	{
		label: "Full Year",
		value: "full_year",
	},
	{
		label: "Partial(Change of Company)",
		value: "partial_change_of_company",
	},
];

export const UKETSEventTypes = [
	{
		label: "Full Year",
		value: "full_year",
	},
	{
		label: "Partial Reporting Period (01-July-2026 to 31-Dec-2026)",
		value: "partial_reporting_period_2026",
	},
	{
		label: "Partial(Change of Company)",
		value: "partial_change_of_company",
	},
	
];
